import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarUsuariosConectados(api, parametros) {
    parametros.operacao = 'buscarUsuariosConectados';

    let retorno = {};
    
    await api.santriGET('/rest/funcionario', parametros, 20, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async buscarFotoFuncionario(api, parametros) {
    parametros.operacao = 'buscarFotoFuncionario'; 

    let retorno = {};
    
    await api.santriGET('/rest/funcionario', parametros, 40, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async buscarUsuarios(api) {
    let parametros = {
      operacao: 'buscarUsuarios'
    }

    let retorno = {};
    
    await api.santriGET('/rest/funcionario', parametros, 20, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async buscarFuncionarios(api, parametros) {
    parametros.operacao = 'buscarFuncionarios';

    let retorno = {};
    
    await api.santriGET('/rest/funcionario', parametros, 20, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/RFuncionario.js